import styled from 'styled-components';
import theme from 'styles/theme';

export const Wrapper = styled.div`
    position: relative;
    display: inline-block;
`;

export const Popup = styled.div`
    position: absolute;
    top: 36px;
    width: 270px;
    height: 274px;
    opacity: 1;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.24);
`;
